// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1EE88","hidden":"style_hidden__mgmkZ"};